import React, { useState, useEffect }from "react"; 
import './css.css';
import securityoperation from '../Assets/security_operations_center-01.svg'
import securityoperationeng from '../Assets/security operations center_soc circle eng.svg'
import confidencialidade from '../Assets/confidencialidade.png'
import integridade from '../Assets/integridade.png'
import disponibilidade from '../Assets/disponibilidade.png'
import seguranca from '../Assets/seguraca.svg'
import operacao from '../Assets/operacao.svg'
import armazenamento from '../Assets/armazenamento.svg'
import adaptabilidade from '../Assets/adaptabilidade.svg'
import apoio from '../Assets/apoio.svg'
import software from '../Assets/software.svg'
import triangolo from '../Assets/tiear.svg'
import triangoloeng from '../Assets/tieareng.svg'
import setas from '../Assets/setas-direitas.svg'
import imgContacto from '../Assets/imagemContacto.png'
import task from '../Assets/task_alt.svg'
import Footer  from '../Footer/Footers';
import Nav  from '../Nav/Nav';
import { Link } from 'react-router-dom';
import logoPhone from '../Assets/phone.svg';
import ponto from '../Assets/pnto.svg';
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom';


const Home = () => {
    useEffect(() => {
        // Adiciona o script ao documento 
        const script = document.createElement('script');
        script.src = 'https://cdn.startbootstrap.com/sb-forms-latest.js';
        script.async = true;
        document.body.appendChild(script);

        // Limpa o script quando o componente é desmontado
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    // State to keep track of the selected tab
    const [selectedTab, setSelectedTab] = useState('tab1');

    // Event handler for changing the selected tab
    const handleSelectChange = (event) => {
        setSelectedTab(event.target.value);
    };
    
    const { t, i18n } = useTranslation();

    const location = useLocation(); // Obtém a URL atual

    // Define o idioma com base na URL
    useEffect(() => {
        if (location.pathname.startsWith('/eng')) {
            i18n.changeLanguage('en');
        } else {
            i18n.changeLanguage('pt');
        }
    }, [location.pathname, i18n]);
    
   // Obter o idioma atual
    const currentLanguage = i18n.language;

    const normalizedLanguage = i18n.language.slice(0, 2).toUpperCase();

    let securite; // Declarar a variável antes de usá-la

    if (normalizedLanguage.toUpperCase() === 'EN') {
        securite = securityoperationeng; 
    } else if (normalizedLanguage.toUpperCase() === 'PT') {
        securite = securityoperation; 
    } else {
        securite = securityoperation; 
    }

    let triangulo; 

    if (normalizedLanguage.toUpperCase() === 'EN' || normalizedLanguage.toUpperCase() === 'EN-EN') {
        triangulo = triangoloeng; 
    } else if (normalizedLanguage.toUpperCase() === 'PT' || normalizedLanguage.toUpperCase() === 'PT-PT') {
        triangulo = triangolo; 
    } else {
        triangulo = triangolo; 
    }


    return (
        <div className="wrap">
           <body id="page-top">
        <Nav />
        <header className="masthead">
            <div className="container vh-60">
                <div className="row gx-4 gx-lg-5 h-100">
                    <div className="col-lg-9 align-self-end mb-2">
                        <h1 className="text-white fw-semibold font-size-titulo">{t('Security Operations Center')}</h1>
                        
                    </div>  
                    <div className="col-lg-8 align-self-baseline">
                        <p className="mb-5 font-size-sub text-white lineHeight15">{t('Um serviço especializado end-to-end, com monitorização contínua de ativos e enriquecida com informação de Thread Intelligence, durante e após a resolução dos incidentes de segurança.')}</p>
                    </div>
                </div>
            </div>
        </header>
        <section className="section-about" id="about">
            <div className="container space-vw">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-7">
                        <h2 className="txt_blue mb-2 fw-semibold fontSize-titulo text-pp">{t('SOC da VisionWare')}</h2>
                        <p className="txt_blue font-size-texto txt-width lineHeight15">{t('O objetivo principal do SOC é detetar, analisar e responder a possíveis ameaças de segurança, como ataques cibernéticos, roubo de informações, malware, phishing, entre outros. As equipas do SOC utilizam ferramentas de segurança avançadas para monitorizar redes, sistemas, e responder a incidentes de segurança.')}</p>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                        <div className="aspect-ratio">
                            <iframe 
                                src={
                                    normalizedLanguage === 'EN' 
                                        ? "https://player.vimeo.com/video/1033127471?h=bf2df26ba6" 
                                        : "https://player.vimeo.com/video/948649819?h=a6173fc428"
                                }
                                frameBorder="0" 
                                allow="autoplay; fullscreen; picture-in-picture" 
                                allowFullScreen 
                                title="VisionWare Entrevista Final (1)"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="page-sections " id="about-vw">
            <div className="bg-company">
            <div className="container space-top-vw space-section-card">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 security-operation">
                       <img src={securite} alt="Imagem" className="operation-security"/>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6"> 
                       <h2 className="txt_blue fw-semibold fontSize-titulo line-height mb-2">{t('Não corra riscos. Evite um incidente cibernético.')}</h2>
                       <p className="txt_blue font-size-texto mb-4">{t('Organizações que não possuam um SOC em')} <span className="fw-semibold">{t('funcionamento 24/7')}</span> {t('correm o risco de não detetar um ataque até que o seu impacto se faça sentir e, assim, exacerbar atrasos na resposta a incidentes bem como na recuperação.')}</p>
                       <p className="txt_blue font-size-texto mb-4">{t('O SOC da VisionWare oferece proteção dos dados e ativos através da monitorização, deteção e resposta a ameaças. Concretiza-se numa solução personalizável que oferece estabilidade operacional e recuperação rápida, de forma a minimizar as consequências a longo prazo de um ciberataque.')}</p>
                       <p className="txt_blue font-size-texto">{t('O SOC VisionWare atua em conformidade com as obrigações legais em vigor.')}</p>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 security-op mt2 ">
                       <img src={securite} alt="Imagem" className="img-fluid mt-mb"/>
                    </div>
                </div>
                <div className="row space-top-vw">
                    <div className="col-lg-12">
                        <h2 className="txt_blue fw-semibold mb-4 title-txt-width lineHeight15"> 
                            {t('Defenda a sua Empresa, recorrendo a quem sabe. Escolha a VisionWare.')}
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <p className="txt_blue font-size-texto">{t('Uma das opções para garantir uma maior preservação e defesa das informações é precisamente, a adoção de um SOC. A sua utilização auxilia fortemente as Empresas, na proteção das suas atividades.')}</p>
                        <p className="txt_blue font-size-texto wt-vw">{t('A sua implementação permite que a empresa evite perdas significativas e eventuais ataques profissionais de hackers, algo que poderia comprometer seriamente a continuidade do seu negócio ou até provocar quebras de atividade e elevados danos reputacionais.')}</p>
                    </div>
                    <div className="col-lg-6">
                        <p className="txt_blue font-size-texto fw-semibold"> {t('Um SOC inteligente permite que as equipas de segurança:')}</p>
                        <div className="d-flex flex-row align-items-center">
                            <div className="mr-4">
                               <img src={task} alt="Imagem" className="mr-4"/>
                            </div>
                            <div className="txt_blue font-size-texto">
                             {t('Construam uma arquitetura de SIEM personalizável e segura;')}                 
                            </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mt-2">
                            <div className="mr-4">
                               <img src={task} alt="Imagem" className="mr-4"/>
                            </div>
                            <div className="txt_blue font-size-texto">
                              {t('Aproveitem as análises de segurança avançadas;')}                 
                            </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mt-2">
                            <div className="mr-4">
                               <img src={task} alt="Imagem" className="mr-4"/>
                            </div>
                            <div className="txt_blue font-size-texto">
                                {t('Exploram a inteligência integrada contra ameaças;')}                
                            </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mt-2">
                            <div className="mr-4">
                               <img src={task} alt="Imagem" className="mr-4"/>
                            </div>
                            <div className="txt_blue font-size-texto">
                                {t('Automatizem o processo de deteção de ameaças e resposta a incidentes tornando-o mais rápido e assertivo;')}                 
                            </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mt-2">
                            <div className="mr-4">
                               <img src={task} alt="Imagem" className="mr-4"/>
                            </div>
                            <div className="txt_blue font-size-texto">
                                {t('Investiguem e visualizem ameaças e soluções.')}               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            </div>
        </section>
        
      
        <section className="page-section-vw vw" id="about">
            <div className="container">
                <div className="position-card  cards-none-mb">
                    <div className="row tow-card">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                            <div className="text-center bg-card padding-card">
                                <img src={confidencialidade} alt="Imagem" className="img-fluid mb-2"/>
                                <p className="text-white font-size-sub fw-bold mb-title">{t('Confidencialidade')}</p>
                                <div className="txt-center"> <p className="text-white font-size-11 txt-center txt-caixas mb-title">{t('Segurança dos Clientes e Colaboradores')}</p></div>
                               
                            </div>
                        </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div className="text-center bg-card padding-card">
                                    <img src={integridade} alt="Imagem" className="img-fluid mb-2"/>
                                    <p className="text-white font-size-sub fw-bold mb-title">{t('Integridade')}</p>
                                    <div className="txt-center"><p className="text-white font-size-11 txt-caixas mb-title">{t('Preservação da precisão e veracidade da informação')}</p></div>
                                    
                                </div>
                        </div>
                            <div className="col-lg-4">
                                <div className="text-center bg-card padding-card-d">
                                    <img src={disponibilidade} alt="Imagem" className="img-fluid mb-2"/>
                                    <p className="text-white font-size-sub fw-bold mb-title">{t('Disponibilidade')}</p>
                                    <p className="text-white font-size-11 txt-center mb-title">{t('Sistema do cliente prontamente acessível e em cumprimento com os níveis de qualidade e serviço acordados')}</p>
                                </div>
                                
                            </div>
                    </div>
                </div>


                <div className="cards-block-mb space-buttom-vw">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-c">
                            <div className="text-center bg-card padding-card">
                                <img src={confidencialidade} alt="Imagem" className="img-fluid mb-2"/>
                                <p className="text-white font-size-15 fw-bold mb-title">{t('Confidencialidade')}</p>
                                <div className="txt-center"><p className="text-white font-size-11 txt-caixas mb-title">{t('Segurança dos Clientes e Colaboradores')}</p></div>
                                
                            </div>
                        </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-integration">
                                <div className="text-center bg-card padding-card">
                                    <img src={integridade} alt="Imagem" className="img-fluid mb-2"/>
                                    <p className="text-white font-size-15 fw-bold mb-title">{t('Integridade')}</p>
                                    <div className="txt-center"> 
                                        <p className="text-white font-size-11 txt-center txt-caixas mb-title">{t('Preservação da precisão e veracidade da informação')}</p>
                                    </div>
                                </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-d">
                            <div className="text-center bg-card padding-card-d">
                                <img src={disponibilidade} alt="Imagem" className="img-fluid mb-2"/>
                                <p className="text-white font-size-15 fw-bold mb-title">{t('Disponibilidade')}</p>
                                <p className="text-white font-size-11 txt-center mb-title">{t('Sistema do cliente prontamente acessível e em cumprimento com os níveis de qualidade e serviço acordados')}</p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row mb-4">
                     <div className="col-lg-6">
                        <h2 className="txt_blue fw-semibold fontSize-titulo">{t('O que distingue a VisionWare')}</h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-lg-6">
                        <p className="txt_blue font-size-texto mb-4 width-90">{t('O foco principal do SOC da VisionWare é a cibersegurança dos seus ativos.')} </p>
                        <p className="txt_blue font-size-texto mb-4 width-90">{t('O SOC compromete-se a procurar proativamente ameaças e identificar vulnerabilidades, antes que possam ser exploradas, enquanto que oferece suporte na resposta perante eventuais incidentes.')}</p>
                        <p className="txt_blue font-size-texto width-90">{t('Valorizamos ao máximo a integração no seu workflow, mantendo o foco numa maior flexibilidade de ajuste e personalização à sua infraestrutura, sem limites de armazenamento e com recurso a softwares sofisticados para a recolha de eventos detalhados.')}</p>
                    </div>
                    <div className="col-lg-6">
                       <p className="txt_blue font-size-texto mb-4">{t('Posteriormente, estes eventos são enriquecidos com feeds de inteligência, de forma manual.')}</p>
                        <p className="txt_blue font-size-texto mb-4">{t('Esta ferramenta, recolhe, analisa e partilha informações sobre ameaças de segurança, em tempo real e através do cruzamento de dados com várias fontes.')} </p>
                        <p className="txt_blue font-size-texto mb-4 mt-txto">{t('Além da tecnologia avançada, o SOC da Visionware contempla a monitorização contínua  através da ação de uma equipa multidisciplinar de analistas especializados, disponíveis 24/7 privilegiando sempre a comunicação contínua e regular com o cliente.')}</p>
                    </div>
                </div>
                <div className="row space-top-vw">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 seguranca-cad">
                        <div className="card card-vw">
                        <div className="card-body padding-cardbody">
                            <img src={seguranca} alt="Segurança de Arquitetura" className="img-fluid mb-2" />
                            <div className="txt-hight">
                            <h3 className="txt-color-b fw-semibold font-size-sub">{t('Segurança de Arquitetura')}</h3>
                            <p className="txt_blue font-size-11">{t('Flexibilidade na integração da infraestrutura do cliente')}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 operacao-card">
                        <div className="card card-vw">
                        <div className="card-body padding-cardbody">
                            <img src={operacao} alt="Operações de Segurança" className="img-fluid mb-2" />
                            <div className="txt-hight">
                            <h3 className="txt-color-b fw-semibold font-size-sub">{t('Operações de Segurança')}</h3>
                            <p className="txt_blue font-size-11">{t('Equipa CSIRT opera 24/7')}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 armazem-card">
                        <div className="card card-vw">
                        <div className="card-body padding-cardbody">
                            <img src={armazenamento} alt="Armazenamento" className="img-fluid mb-2" />
                            <div className="txt-hight">
                            <h3 className="txt-color-b fw-semibold font-size-sub">{t('Armazenamento')}</h3>
                            <p className="txt_blue font-size-11">{t('Sem limites de armazenamento e sem custos adicionais')}</p>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <div className="card card-vw">
                        <div className="card-body padding-cardbody">
                            <img src={adaptabilidade} alt="Adaptabilidade" className="img-fluid mb-2" />
                            <div className="txt-hight">
                            <h3 className="txt-color-b fw-semibold font-size-sub">{t('Adaptabilidade')}</h3>
                            <p className="txt_blue font-size-11">{t('Serviço personalizado ao cliente, sem limite de armazenamento')}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <div className="card card-vw">
                        <div className="card-body padding-cardbody">
                            <img src={apoio} alt="Apoio Dedicado" className="img-fluid mb-2" />
                            <div className="txt-hight">
                            <h3 className="txt-color-b fw-semibold font-size-sub">{t('Apoio Dedicado')}</h3>
                            <p className="txt_blue font-size-11">{t('Comunicação contínua e regular com o cliente, sempre que se justifique')}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <div className="card card-vw">
                        <div className="card-body padding-cardbody">
                            <img src={software} alt="Software Especializado" className="img-fluid mb-2" />
                            <div className="txt-hight">
                            <h3 className="txt-color-b fw-semibold font-size-sub">{t('Software Especializado')}</h3>
                            <p className="txt_blue font-size-11">{t('Utilização de ferramentas de SIEM, IDS/IPS e Threat Intelligence')}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>


                <div class="row space-top-vw space-buttom-vw">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3">
                    <div class="col-9 col-sm-7 col-md-8 col-lg-8 col-xl-10 col-xxl-9 ">
                        <div class="h-100 rounded border-0 mb-0">
                            <div class="card-body card-peding">
                                <div class="align-items-center">
                                    <span class="d-flex align-items-start mb-0">
                                        <div>
                                            <h3 class="font-size-hs d-block mb-0 color-ones number-sob2 mr-4 mb-2 fw-bold">
                                                 +100<sub
                                                    class="font-size-1 number-sob2 color-colabaorador sub-projetct ml-2 fw-bold">{t('Colaboradores')}</sub>
                                            </h3>
                                            <small class="d-block ">
                                                <p class="font-size-texto font-weight-normal projt-texto-h txt_blue ">
                                                    {t('a apoiar os nossos clientes desde 2005')}
                                                </p>
                                            </small>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 ">
                    <div class="col-9 col-sm-12 col-md-9 col-lg-8 col-xl-12">
                        <div class=" h-100 rounded border-0   mb-0">
                            <div class="card-body card-peding">
                                <div class="align-items-center">
                                    <span class="d-flex align-items-start mb-0" href="#">
                                        <div>

                                            <h3 class="font-size-hs d-block mb-0 color-two number-sob2 mr-4 mb-2 fw-bold">
                                                +10<sub
                                                    class="font-size-1 number-sob2 color-geografia sub-projetct ml-2 fw-bold">{t('Geografias')}</sub>
                                            </h3>
                                            <small class="d-block ">
                                                <p
                                                    class="font-size-texto font-weight-normal  texto-sobcento projt-texto-h txt_blue">
                                                   {t('empresa portuguesa com projeção e dimensão global')}
                                                </p>
                                            </small>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3">
                    <div class="col-9 col-sm-12 col-md-10 col-lg-12 col-xl-12 remove-pp">
                        <div class="h-100 rounded border-0 mb-0">
                            <div class="card-body card-peding">
                                <div class="align-items-center">
                                    <span class="d-flex align-items-start mb-0" href="#">
                                        <div>
                                            <h3 class="font-size-hs d-block mb-0 color-trhee number-sob3 mr-4 mb-2 fw-bold">
                                                +5000<sub
                                                    class="font-size-1 number-sob3 color-projeto sub-projetct ml-2 fw-bold">{t('Projetos')}</sub>
                                            </h3>
                                            <small class="d-block ">
                                                <p class="font-size-texto font-weight-normal  texto-sobcento projt-texto-h txt_blue">
                                                {t('em todos os setores de atividade, de forma transversal')}
                                                </p>
                                            </small>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-lg-6 col-xl-3 ">
                    <div class="col-9 col-sm-12 col-md-10 col-lg-8 col-xl-12">
                        <div class=" h-100 rounded border-0   mb-0">
                         
                            <div class="card-body card-peding">
                                <div class="align-items-center">
                                    <span class="d-flex align-items-start mb-0" href="#">
                                        <div>

                                            <h3 class="font-size-hs d-block mb-0 color-four number-sob4 mr-4 mb-2 fw-bold">
                                                +19<sub
                                                    class="font-size-1 number-sob4 color-txto-ana sub-projetct ml-2 fw-bold">{t('anos de experiência')}</sub>
                                            </h3>
                                            <small class="d-block ">
                                                <p class="font-size-texto font-weight-normal  texto-sobcento projt-texto-h txt_blue">
                                                {t('confiança e reconhecimento dos nossos clientes')}
                                                </p>
                                            </small>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                
            </div>
            
        </section>
        <section className="bg-section">
            <div className="container space-vw">
                <div className="row">
                    <div className="col-lg-6">
                         <h2 class="fw-bold text-white mt-3 fontSize-titulo">{t('Como funciona')}</h2>
                         <p className="font-size-11 text-white txt-paramede">{t('A Security Response Team da VisionWare é responsável pelas ações de contenção de ataques, trabalhando com vigilância 24/7/365, focada numa abordagem e serviço especializado end-to-end. Como vantagem adicional, destaca-se a sua atuação em diferentes geografias, através de uma plataforma de gestão de eventos.')}</p>
                         <p className="font-size-10 text-white">{t('*Tiers são as camadas/níveis que compõem a equipa.')}</p>
                    </div>
                    <div className="col-lg-6 mt-mb">
                         <img src={triangulo} alt="Imagem" className="img-fluid"/>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div className="container space-vw">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                       <h2 class="txt_blue fw-bold mb-3 line-height">{t('Saiba como detetar, prevenir e proteger a sua empresa da persistente e imparável evolução de ciberataques, cada vez mais eficientes, sofisticados e complexos.')}</h2>
                    </div>
                </div>
                <div className="row mt-5 no-responsive">
                    <div class="tab-container">
                        <input type="radio" id="tab1" name="tab-control" />
                        <input type="radio" id="tab2" name="tab-control" />
                        <input type="radio" id="tab3" name="tab-control" />
                        <input type="radio" id="tab4" name="tab-control" />
                        <input type="radio" id="tab5" name="tab-control" />
                        
                        <ul class="tab-labels">
                            <li><label for="tab1" role="button" className="font-size-texto">{t('Identificação')}</label>
                                <hr  className="actives"/>
                                <hr className="hr-vw tab-op-0"/>
                            </li>
                            <li><label for="tab2" role="button" className="font-size-texto">{t('Contenção')}</label>
                                <hr className="hr-vw"/>
                            </li>
                            <li><label for="tab3" role="button" className="font-size-texto">{t('Erradicação')}</label>
                                <hr className="hr-vw"/>
                            </li>
                            <li><label for="tab4" role="button" className="font-size-texto">{t('Recuperação')}</label>
                                <hr className="hr-vw"/>
                            </li>
                            <li><label for="tab5" role="button" className="font-size-texto">{t('Lições aprendidas')}</label>
                                <hr className="hr-vw"/>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <section section id="tab0">
                                <h2 className="fw-bold txt_blue mb-3 font-size-texto" >{t('Identificação')}</h2>
                                <p  className="font-size-11 txt_blue txt-paramede txt-right mb-0">{t('Este passo implica detetar desvios das operações normais na organização, compreender se um desvio representa um incidente de segurança, e determinar a importância do incidente. O procedimento de identificação da resposta ao incidente, inclui monitorização dos sistemas e infraestrututra de TI, análise de eventos de múltiplas fontes, identificação de um incidente através de correlação de dados e notificar a equipa de resposta a incidentes.')}</p>
                            </section>
                            <section id="tab1">
                                <h2 className="fw-bold txt_blue mb-3 font-size-texto" >{t('Identificação')}</h2>
                                <p  className="font-size-11 txt_blue txt-paramede txt-right mb-0">{t('Este passo implica detetar desvios das operações normais na organização, compreender se um desvio representa um incidente de segurança, e determinar a importância do incidente. O procedimento de identificação da resposta ao incidente, inclui monitorização dos sistemas e infraestrututra de TI, análise de eventos de múltiplas fontes, identificação de um incidente através de correlação de dados e notificar a equipa de resposta a incidentes.')}</p>
                            </section>
                            <section id="tab2">
                                 <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Contenção')}</h2>
                                 <p  className="font-size-11 txt_blue txt-paramede txt-right mb-0">{t('Limitar os danos do atual incidente de segurança e prevenir quaisquer outros danos. Assegurar as necessárias medidas para mitigar completamente o incidente, ao mesmo tempo que se evita a destruição de provas que possam ser necessárias para a acusação.')}</p>
                            </section>
                            <section id="tab3">
                                 <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Erradicação')}</h2>
                                 <p  className="font-size-11 txt_blue txt-paramede txt-right mb-0">{t('A erradicação destina-se a remover efetivamente o malware ou outros artefactos introduzidos pelos ataques, e a restaurar completamente todos os sistemas afetados.')}</p>
                            </section>
                            <section id="tab4">
                                 <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Recuperação')}</h2>
                                 <p  className="font-size-11 txt_blue txt-paramede txt-right mb-0">{t('O objetivo da recuperação é trazer todos os sistemas de volta ao seu pleno funcionamento, depois de verificar que estão limpos e que a ameaça é removida.')}</p>
                            </section>
                            <section id="tab5">
                                 <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Lições aprendidas')}</h2>
                                 <p  className="font-size-11 txt_blue txt-paramede txt-right mb-0">{t('Após o incidente, a equipa de resposta a incidentes deverá compilar todas as informações relevantes sobre o incidente e extrair lições que possam ajudar na atividade de resposta a futuros incidentes.')}</p>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row mt-5 responsive marge-drop">
                    <select value={selectedTab} onChange={handleSelectChange} id="assunto" class="form-control form-control-sm form-select form-select-lg mb-3" aria-label="Large select example">
                        <option selected value="tab1" className="font-size-texto option-soc">{t('Identificação')}</option>
                        <option value="tab2" className="h7 txt_cor font-size-texto option-soc">{t('Contenção')}</option>
                        <option value="tab3" className="h7 txt_cor font-size-texto option-soc">{t('Erradicação')}</option>
                        <option value="tab4" className="h7 txt_cor font-size-texto option-soc">{t('Recuperação')}</option>
                        <option value="tab5" className="h7 txt_cor font-size-texto option-soc">{t('Lições aprendidas')}</option>
                    </select>
                    <div className="tab-content">
                        <section id="tab1" style={{ display: selectedTab === 'tab1' ? 'block' : 'none' }}>
                            <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Identificação')}</h2>
                            <p className="font-size-11 txt_blue txt-paramede">
                            {t('Este passo implica detetar desvios das operações normais na organização, compreender se um desvio representa um incidente de segurança, e determinar a importância do incidente. O procedimento de identificação da resposta ao incidente inclui monitorização dos sistemas e infraestrutura de TI, análise de eventos de múltiplas fontes, identificação de um incidente através de correlação de dados e notificar a equipa de resposta a incidentes.')}
                            </p>
                        </section>
                        <section id="tab2" style={{ display: selectedTab === 'tab2' ? 'block' : 'none' }}>
                            <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Contenção')}</h2>
                            <p className="font-size-11 txt_blue txt-paramede">
                            {t('Limitar os danos do atual incidente de segurança e prevenir quaisquer outros danos. Assegurar as necessárias medidas para mitigar completamente o incidente, ao mesmo tempo que se evita a destruição de provas que possam ser necessárias para a acusação.')}
                            </p>
                        </section>
                        <section id="tab3" style={{ display: selectedTab === 'tab3' ? 'block' : 'none' }}>
                            <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Erradicação')}</h2>
                            <p className="font-size-11 txt_blue txt-paramede">
                             {t('A erradicação destina-se a remover efetivamente o malware ou outros artefactos introduzidos pelos ataques, e a restaurar completamente todos os sistemas afetados.')} 
                            </p>
                        </section>
                        <section id="tab4" style={{ display: selectedTab === 'tab4' ? 'block' : 'none' }}>
                            <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Recuperação')}</h2>
                            <p className="font-size-11 txt_blue txt-paramede">
                              {t('O objetivo da recuperação é trazer todos os sistemas de volta ao seu pleno funcionamento, depois de verificar que estão limpos e que a ameaça foi removida.')}
                            </p>
                        </section>
                        <section id="tab5" style={{ display: selectedTab === 'tab5' ? 'block' : 'none' }}>
                            <h2 className="fw-bold txt_blue mb-3 font-size-texto">{t('Lições aprendidas')}</h2>
                            <p className="font-size-11 txt_blue txt-paramede">
                            {t('Após o incidente, a equipa de resposta a incidentes deverá compilar todas as informações relevantes sobre o incidente e extrair lições que possam ajudar na atividade de resposta a futuros incidentes.')}
                            </p>
                        </section>
                    </div>
                </div>

                <div className="row space-top-vwd">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <h2 className="fw-bold txt_blue mb-3 line-height d-width">{t('Dúvidas Gerais ou Pedidos de Informação e Solicitação de Reunião')}</h2>
                    </div>
                <div className="accordion" id="accordionBilling">
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header  card-faq" id="headingOne"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">{t('O que é o SOC?')}</button></h5>
                        <div className="accordion-collapse collapse show" id="collapseOne" aria-labelledby="headingOne" data-bs-parent="#accordionBilling" ><div className="accordion-body p-4 font-size-11">{t('Um Security Operation Center (SOC) é uma função centralizada dentro de uma organização que combina especialistas, processos e tecnologia que protege os sistemas de informação da sua organização através de: design e configurações proativas, monitorização contínua do estado do sistema, deteção de ações não intencionais ou estados indesejáveis, minimização de danos causados por efeitos indesejados e investigação forense.')}</div></div>
                    </div>
                    <div className="card  card-faq mt-4">
                        <h5 className="accordion-header" id="headingTwo"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">{t('No que consiste o serviço SOC?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseTwo" aria-labelledby="headingTwo" data-bs-parent="#accordionBilling"><div className="accordion-body p-4 font-size-11">{t('SOC-as-a-Service (SOCaaS) é um modelo de segurança em que um fornecedor terceirizado opera e mantém um SOC. O SOCaaS fornece todas as funções de segurança executadas por um SOC interno tradicional, incluindo: monitorização de rede; gestão de logs; deteção de ameaças e intelligence; investigação e resposta a incidentes; relatórios e analises de risco e conformidade. O fornecedor também assume a responsabilidade por todas as pessoas, processos e tecnologias necessárias para habilitar esses serviços e fornecer suporte 24 horas por dia, 7 dias por semana.')}</div></div>
                    </div>
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header" id="headingThree"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">{t('SOC as a service é o mesmo que MDR?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseThree" aria-labelledby="headingThree" data-bs-parent="#accordionBilling" ><div class="accordion-body p-4 font-size-11">{t('Ambos são serviços de cibersegurança que combinam tecnologia e conhecimento humano para realizar a monitorização, deteção e resposta a ameaças. No entanto, o SOCaaS, por definição, é um serviço terceirizado, o que nem sempre é o caso do MDR. O SOCaaS também fornece uma gama maior de serviços e oferece proteção mais forte e abrangente em comparação com uma ferramenta MDR.')}</div></div>
                    </div>
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header" id="headingTem"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTem" aria-expanded="false" aria-controls="collapseTem">{t('O que é conformidade no SOC?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseTem" aria-labelledby="headingTem" data-bs-parent="#accordionBilling" ><div class="accordion-body p-4 font-size-11">{t('A conformidade no SOC garante uma abordagem de gestão de riscos assente em medidas e controlos de segurança, predefinidos e aceites coletivamente, para garantir a conformidade com as leis  e regulamentos em vigor.  A conformidade orienta as organizações em direção às melhores práticas de cibersegurança existentes e aos protocolos que minimizam as chances de violações de dados com um propósito que beneficia ambas as partes: organização, regulador e clientes.')}</div></div>
                    </div>
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header" id="headingFour"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">{t('Que tipos de ameaças é que o SOC deteta?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseFour" aria-labelledby="headingFour" data-bs-parent="#accordionBilling" ><div class="accordion-body p-4 font-size-11">{t('SOC foi projetado para detetar uma ampla gama de ameaças de segurança, incluindo malware, ransomware, ataques de phishing, violações de dados, ameaças internas e muito mais. O serviço utiliza  ferramentas avançadas de inteligência e análise de ameaças para identificar ameaças potenciais e responder perante as mesmas em tempo real.')}</div></div>
                    </div>
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header" id="headingFive"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">{t('Qual a metodologia de um SOC para responder a incidentes?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseFive" aria-labelledby="headingFive" data-bs-parent="#accordionBilling" ><div class="accordion-body p-4 font-size-11">{t('A equipa de resposta a incidentes da VisionWare, desenvolveu os seus processos de resposta a incidente tendo por base frameworks internacionais, tais como:')} 
                                <div className="d-flex flex-row align-items-center"><div className="mr-2"><img src={ponto} alt="Imagem" className="mt-3" /></div><div className="font-size-11 txt_blue mt-3">{t('ISO/IEC 27035 - Information Security Incident Management;')}</div></div>
                                <div className="d-flex flex-row align-items-center"><div className="mr-2"><img src={ponto} alt="Imagem" className="mt-3" /></div><div className="font-size-11 txt_blue mt-3">{t('NIST 800-61 – Computer Incident Handling Guide;')}</div></div>
                                <div className="d-flex flex-row align-items-center"><div className="mr-2"><img src={ponto} alt="Imagem" className="mt-3" /></div><div className="font-size-11 txt_blue mt-3">{t('SANS PICERL  Incident Lifecycle;')}</div></div>
                                <div className="d-flex flex-row align-items-center"><div className="mr-2"><img src={ponto} alt="Imagem" className="mt-3" /></div><div className="font-size-11 txt_blue mt-3">{t('As fases de resposta são: identificação; Contenção; Erradicação; Recuperação; e Lições Aprendidas.')}</div></div>
                        </div>
                        </div>
                    </div>
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header" id="headingSixe"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixe" aria-expanded="false" aria-controls="collapseSixe">{t('O que são as ferramentas SOC?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseSixe" aria-labelledby="headingSixe" data-bs-parent="#accordionBilling" >
                            <div class="accordion-body p-4 font-size-11">
                            {t('As ferramentas SOC abrangem uma gama de funcionalidades que auxiliam as equipas de segurança a detetar e a responder perante ameaças. Algumas ferramentas incluem: Log collection and management tool; Cyber Threat Intelligence; Vulnerability management; Security information and event management (SIEM); Network Intrusion Detection System; Endpoint detection and response (EDR); Behaviorial monitoring, etc.')}
                               <p>{t('A VisionWare CyberShield SIEM incorpora todas estas funcionalidades.')} </p> 
                        </div></div>
                    </div>
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header" id="headingSeven"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">{t('O que são ferramentas SIEM?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseSeven" aria-labelledby="headingSeven" data-bs-parent="#accordionBilling" ><div class="accordion-body p-4 font-size-11">{t('Security Information and Event Management (SIEM), é uma solução que ajuda as organizações a detetar, analisar e responder a ameaças de segurança antes que as mesmas causem um impacto disruptivo. As ferramentas SIEM recolhem dados de log de eventos de várias fontes, identificam atividades que se desviam da norma com análise em tempo real e tomam as medidas apropriadas.')}</div></div>
                    </div>
                    <div className="card card-faq mt-4">
                        <h5 className="accordion-header" id="headingEight"><button className="accordion-button p-3 collapsed bg-btn-card font-size-11 txt_blue fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">{t('Como posso contactar a equipa de SOC?')}</button></h5>
                        <div className="accordion-collapse collapse" id="collapseEight" aria-labelledby="headingEight" data-bs-parent="#accordionBilling" ><div class="accordion-body p-4 font-size-11">
                            <p className="font-size-11 txt_blue">{t('Na VisionWare, dispomos de uma plataforma de ticketing, na qual, para além da criação de tickets automatizados do SIEM, será ainda possível criar tickets via:')}</p>
                            <div className="d-flex flex-row align-items-center"><div className="mr-2"><img src={ponto} alt="Imagem" className="mt-3" /></div><div className="font-size-11 txt_blue mt-3">{t('Email;')}</div></div>
                            <div className="d-flex flex-row align-items-center"><div className="mr-2"><img src={ponto} alt="Imagem" className="mt-3" /></div><div className="font-size-11 txt_blue mt-3">{t('Telefone;')}</div></div>
                            <div className="d-flex flex-row align-items-center"><div className="mr-2"><img src={ponto} alt="Imagem" className="mt-3" /></div><div className="font-size-11 txt_blue mt-3">{t('Telegram.')}</div></div>
                        </div></div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <section id="contact-vw">
            <div className="container space-buttom-vw">
            <div className="row none-div-mb">
    <div className="col-lg-3 remove-pd-img">
        <div>
            <img src={imgContacto} alt="Imagem" className="img-fluid altura-img"/>
        </div>
    </div>
    <div className="col-12 col-sm-12 col-md-12 col-lg-9 bg-contactos">
                <div className="row pd-cadp caixa-texto">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8">
                                <h2 className="fw-bold txt_blue mb-3 font-sizec">{t('Conte com o apoio da VisionWare')}</h2>
                                <p className="font-size-11 txt_blue text-wp">{t('Se tem dúvidas, necessita de algum esclarecimento ou informação adicional, não hesite em contactar a VisionWare.')}</p>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 d-flex align-items-center justify-content-center">
                                <Link className="btn-vw btn-primary-vw btn-hover-contacto-nos btnx-soc text-white width-100" to="tel:+351225323740">
                                    <span className="mr-2">
                                        <img src={logoPhone} alt="Imagem" className="img-fluid"/>
                                    </span>
                                    <span>(+351) 225 323 740</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row show-div-mb">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 bg-contactos">
                        <div className="row pd-cad">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <h2 class="fw-bold txt_blue mb-3 line-height">{t('Conte com o apoio da VisionWare')}</h2>
                                <p className="font-size-11 txt_blue ">{t('Se tem dúvidas, necessita de algum esclarecimento ou informação adicional, não hesite em contactar a VisionWare.')}</p>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3">
                                
                                <Link class="btn-vw btn-primary-vw btn-hover-contacto-nos btnx-soc text-white width-100" to="tel:+351225323740">
                                     <span className="mr-2 "><img src={logoPhone} alt="Imagem" className="img-fluid"/></span> <span className="">(+351) 225 323 740</span>  
                                </Link>          
                                 
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        < Footer />
       
    </body>
        </div>
        
    )
}
export default Home;